import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconFolderBookmarks: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="folder-bookmarks"><path d="M1.75 13.75H7.25V20.25L4.5 18.75L1.75 20.25V13.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M10.25 19.25H21.25V6.75H12L10 3.75H2.75V10.75" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconFolderBookmarks;
